// Import contract ABIs
import ERC20_ABI from "../abis/ERC20.json";
import FACTORY_ABI from "../abis/Factory.json";
import ROUTER_ABI from "../abis/Router02.json";
import NEXT_TOKEN_ABI from "../abis/NextToken.json";
import BUY_NODE_ABI from "../abis/BuyNode.json";
import STAKING_ABI from "../abis/Staking.json";
import REFERRAL_ABI from "../abis/Referral.json";
import TICKET_ABI from "../abis/Ticket.json";
import PACKS_ABI from "../abis/Packs.json";
import BONUS_ABI from "../abis/Bonus.json";
import SWAP_ABI from "../abis/Swap.json";
import VT_ABI from "../abis/VT.json";

let CONTRACT_ADDRESSES;
// Checking the staging or live
if (process.env.REACT_APP_ENV === "staging") {
    // Contract addresses for BSC Mainnet
    CONTRACT_ADDRESSES = {
        FACTORY: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        ROUTER: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        WBNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        // Deployed contracts
        NEXT_TOKEN: "0x718aB29275D7EAB2A65D76CE94a39E600B831eb2",
        // BUY_NODE: "0x529642CB0d7496FbfBf71A2ff88fd307768A2828",
        BUY_NODE: "0x529642CB0d7496FbfBf71A2ff88fd307768A2828",
        TICKETING: "0x9ee3552Bb5018f475eb965e0721bF7D711254603",
        // STAKING: "0x9aCd3c2553AaFfB9A726ee4DffF590E07ED96935",
        // STAKING: "0xe85723F061A116517Cf3ABD78e1a9bF271Fe8ECE",
        STAKING: "0x2ef80DF8373Ab2A2Ad3f6E6Ed4D689a7E0d02C1B",
        USDT: "0xfa689719189fA0c8E1571AeCf4527960B8f62f32",
        PACKS: "0xa8DA24099C3861d8A98189E3d93333281B473A33",
        REFERRALS: "0xae811338E6B4993c95B0ac43431339428f185Aa4",
        Bonus: "0xb914c38314db5EE59d080CfA08A9eF3B5d8D8d51",
        SWAP: "0xF668014d42c5deD77f7a3a40E4a58Da5611f2cCA",
        VT: "0x8047C08Bc001f8206cD0A60BB58c793676C5B01B"
    };
} else {
    // Contract addresses for BSC Mainnet
    CONTRACT_ADDRESSES = {
        FACTORY: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        ROUTER: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        WBNB: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
        // Deployed contracts
        NEXT_TOKEN: "0x38323Fdd3fFD0005333F20A8c8B97bB3440FAba6",
        BUY_NODE: "0x5220f16b61e7Dc07de2d3B150D2ee8011e2fb669",
        TICKETING: "0x7cEb9054ecfae19e167bbe51BC3d1491D6815387",
        STAKING: "0x2ef80DF8373Ab2A2Ad3f6E6Ed4D689a7E0d02C1B",
        USDT: "0x55d398326f99059fF775485246999027B3197955",
        PACKS: "0x498D3E29e3DF158f541d9EaA0dc01d182380ff59",
        REFERRALS: "0xae811338E6B4993c95B0ac43431339428f185Aa4",
        Bonus: "0xa9F4E0Aa5B8f3b2D6F0Ade5198988e2E50cC3CcE",
        SWAP: "0x37927da3C524643FAF8D666c1e0119cc64fb415c",
        VT: "0x8047C08Bc001f8206cD0A60BB58c793676C5B01B"
    };
}

export { CONTRACT_ADDRESSES };

let API_BASE = '';

if (process.env.REACT_APP_ENV === 'staging') {
    API_BASE = "https://public-buynode-pokemon.madxapp.com";
} else {
    API_BASE = "https://public-buynode-pokemon.tcg.zone";
}

export { API_BASE };

// Multiple RPC URLs for better reliability. Optional: set REACT_APP_BSC_RPC_URL to prepend a custom RPC (e.g. TokenPocket).
const CUSTOM_BSC_RPC = process.env.REACT_APP_BSC_RPC_URL?.trim();
const BSC_MAINNET_LIST = [
    ...(CUSTOM_BSC_RPC ? [CUSTOM_BSC_RPC] : []),
    // "https://soft-hardworking-water.bsc.quiknode.pro/9f33dfcaa80a15a467e4682c109fd7999e39c226",
    "https://bsc-dataseed1.binance.org/",
    "https://bsc-dataseed2.binance.org/",
    "https://bsc-dataseed3.binance.org/",
    "https://bsc-dataseed4.binance.org/",
    "https://bsc-dataseed1.defibit.io/",
    "https://bsc-dataseed1.ninicoin.io/",
];

export const RPC_URLS = {
    BSC_MAINNET: BSC_MAINNET_LIST,
    BSC_TESTNET: "https://data-seed-prebsc-1-s1.binance.org:8545/",
};

// Default slippage settings
export const DEFAULT_SLIPPAGE = 0.5;

// Transaction deadline (20 minutes)
export const TRANSACTION_DEADLINE = 60 * 20;

// Toast positions
export const TOAST_POSITION = "top-right";

export const BSC_CHAIN_ID = 56;

export const NETWORK_CONFIG = {
    BSC_MAINNET: {
        chainId: "0x38", // 56 in decimal
        chainName: "Binance Smart Chain",
        nativeCurrency: {
            name: "BNB",
            symbol: "BNB",
            decimals: 18,
        },
        rpcUrls: BSC_MAINNET_LIST,
        blockExplorerUrls: ["https://bscscan.com/"],
    },
};

// Contract ABIs
export const CONTRACT_ABIS = {
    USDT: ERC20_ABI,
    FACTORY: FACTORY_ABI,
    ROUTER: ROUTER_ABI,
    NEXT_TOKEN: NEXT_TOKEN_ABI,
    BUY_NODE: BUY_NODE_ABI,
    STAKING: STAKING_ABI,
    REFERRALS: REFERRAL_ABI,
    TICKET: TICKET_ABI,
    PACKS: PACKS_ABI,
    BONUS: BONUS_ABI,
    SWAP: SWAP_ABI,
    VT: VT_ABI
};

// Token information
// export const TOKEN_INFO = {
//     NEXT: {
//         address: CONTRACT_ADDRESSES.NEXT_TOKEN,
//         symbol: "NEXT",
//         name: "NextFi Token",
//         decimals: 18,
//         logo: "/images/tokens/next.png",
//     },
//     USDT: {
//         address: CONTRACT_ADDRESSES.USDT,
//         symbol: "USDT",
//         name: "Tether USD",
//         decimals: 18,
//         logo: "/images/tokens/usdt.png",
//     },
//     WBNB: {
//         address: CONTRACT_ADDRESSES.WBNB,
//         symbol: "WBNB",
//         name: "Wrapped BNB",
//         decimals: 18,
//         logo: "/images/tokens/wbnb.png",
//     },
// };

// Contract interaction helpers
export const CONTRACT_HELPERS = {
    // Format token amount for display
    formatTokenAmount: (amount, decimals = 18) => {
        return (parseFloat(amount) / Math.pow(10, decimals)).toFixed(2);
    },

    // Convert display amount to wei
    parseTokenAmount: (amount, decimals = 18) => {
        return (parseFloat(amount) * Math.pow(10, decimals)).toString();
    },

    // Get contract instance
    getContract: (address, abi, provider) => {
        return { address, abi, provider };
    },
};

// Gas settings
export const GAS_SETTINGS = {
    DEFAULT_GAS_LIMIT: 300000,
    BUY_NODE_GAS_LIMIT: 500000,
    APPROVE_GAS_LIMIT: 100000,
};
